// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1FfQG","header":"PatientBlock_header__30Jgp","label":"PatientBlock_label__1lyNf","option":"PatientBlock_option__7olFD"};